export default __webpack_public_path__ + "static/media/icon-wallet.83c2925b.svg";